import React from 'react'
import PropTypes from 'prop-types'

import { FormattedMessage, injectIntl } from 'react-intl'
import * as utils from '../ranking.utils'

const renderFeedInfoVisit = (feed, index, user, players, addPopup, setChatTarget, addHowlSound) => {
  const { data: feedData, type, session } = feed

  switch (type) {
    case 'first_user':
      return (
        <div
          key={`firstUser_${index}`}
          className={`mis--feed__item ${user.id == feedData.userId ? 'important' : ''}`}
        >
          <span className="icon-ranking1"></span>
          <FormattedMessage
            id={user.id == feedData.userId ? 'feed.firstUser' : 'feed.notFirstUser'}
            values={{ name: feedData.colonyName, session }}
          />
        </div>
      )
    case 'session_winner':
      return (
        <div
          key={`sessionWinner_${index}`}
          className={`mis--feed__item ${user.id == feedData.userId ? 'important' : ''}`}
        >
          <span className="icon-ranking1"></span>
          <FormattedMessage
            id={user.id == feedData.userId ? 'feed.sessionWinner' : 'feed.notSessionWinner'}
            values={{ name: feedData.colonyName, session }}
          />
        </div>
      )
    case 'session_loser':
      return (
        <div
          key={`sessionLooser_${index}`}
          className={`mis--feed__item ${user.id == feedData.userId ? 'important' : ''}`}
        >
          <span className="icon-ranking1"></span>
          <FormattedMessage
            id={user.id == feedData.userId ? 'feed.sessionLooser' : 'feed.notSessionLooser'}
            values={{ name: feedData.colonyName, session }}
          />
        </div>
      )
    // extint
    case 'important_battle': {
      let winner = utils.getNameFromLicense(players, feedData.winnerId).colonyName
      const loserId =
        feedData.attackerId == feedData.winnerId ? feedData.defenderId : feedData.attackerId
      let loser = utils.getNameFromLicense(players, loserId).colonyName

      return (
        <div key={`importantBattle_${index}`} className="mis--feed__item important">
          <span className="icon-self-question"></span>
          <FormattedMessage
            id={feedData.attackerId == feedData.winnerId ? 'feed.winBattle' : 'feed.lostBattle'}
            values={{ winner, loser }}
          />
        </div>
      )
    }
    case 'human_resources':
      return (
        <div key={`hr_${index}`} className="mis--feed__item important">
          <span className="icon-rrhh"></span>
          <span>{feedData.message}</span>
        </div>
      )
    case 'FEDERATION_MESSAGE':
      // check that we only display the messages sent to my federationId
      if (feedData.targetId === user.federationId) {
        return (
          <div key={`hr_${index}`} className="mis--feed__item important">
            <span className="icon-shield"></span>
            <span>{feedData.message}</span>
            <div>
              {displayButton(
                'icon-send',
                () => {
                  addPopup('chat_popup')
                  setChatTarget({ type: 'federation', id: feedData.targetId })
                },
                addHowlSound
              )}
            </div>
          </div>
        )
      } else {
        return null
      }
    case 'INDIVIDUAL_MESSAGE':
      // check that we only display the messages sent to me
      if (feedData.targetId === user.id) {
        return (
          <div key={`hr_${index}`} className="mis--feed__item important">
            <span className="icon-rrhh"></span>
            <span>{utils.getNameFromLicense(players, feedData.sourceId).colonyName}</span>
            <span>: {feedData.message}</span>
            <div>
              {displayButton(
                'icon-send',
                () => {
                  addPopup('chat_popup')
                  setChatTarget({ type: 'individual', id: feedData.sourceId })
                },
                addHowlSound
              )}
            </div>
          </div>
        )
      } else {
        return null
      }
    default:
      return null
  }
}

const displayButton = (icon, action, addHowlSound) => {
  return (
    <span
      className={icon}
      onClick={() => {
        action()
        addHowlSound('button_click_icon')
      }}
    ></span>
  )
}

const renderFeedChooser = (
  feed,
  index,
  itemId,
  user,
  players,
  addPopup,
  setChatTarget,
  addHowlSound
) => {
  if (feed && itemId && feed[itemId] && user) {
    return renderFeedInfoVisit(
      feed[itemId],
      index,
      user,
      players,
      addPopup,
      setChatTarget,
      addHowlSound
    )
  }
}

const Post = React.memo(({ feed, index, itemId, user, players, addPopup, setChatTarget, addHowlSound }) => {
  return (
    <div>
      {renderFeedChooser(feed, index, itemId, user, players, addPopup, setChatTarget, addHowlSound)}
    </div>
  )
}, (prevProps, nextProps) => {
  // Custom comparison function for better memoization
  return (
    prevProps.feed === nextProps.feed &&
    prevProps.index === nextProps.index &&
    prevProps.itemId === nextProps.itemId &&
    prevProps.user === nextProps.user &&
    prevProps.players === nextProps.players
  )
})

Post.propTypes = {
  user: PropTypes.object,
  feed: PropTypes.object,
  index: PropTypes.number,
  itemId: PropTypes.string,
  players: PropTypes.array,
  addPopup: PropTypes.func,
  setChatTarget: PropTypes.func,
  addHowlSound: PropTypes.func,
}

export default injectIntl(Post)
